/**
 * 客户关怀记录列表组件
 */

import React from 'react';
import { Card, List, Button, Space, Tag } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import type { CustomerCareRecord } from '../types';

interface CustomerCareListProps {
    records: CustomerCareRecord[];
    icon: React.ReactNode;
    onEdit: (record: CustomerCareRecord) => void;
    onDelete: (record: CustomerCareRecord) => void;
}

export const CustomerCareList: React.FC<CustomerCareListProps> = ({ records, icon, onEdit, onDelete }) => {
    return (
        <Card title="历史记录" style={{ marginTop: 16 }}>
            <List
                dataSource={records}
                locale={{ emptyText: '暂无记录' }}
                renderItem={item => (
                    <List.Item
                        actions={[
                            <Button key="edit" type="link" icon={<EditOutlined />} onClick={() => onEdit(item)}>
                                编辑
                            </Button>,
                            <Button
                                key="delete"
                                type="link"
                                danger
                                icon={<DeleteOutlined />}
                                onClick={() => onDelete(item)}
                            >
                                删除
                            </Button>,
                        ]}
                    >
                        <List.Item.Meta
                            avatar={icon}
                            title={
                                <Space>
                                    {item.subject || '售后卡'}
                                    {item.attachments.length > 0 && (
                                        <Tag color="blue">{item.attachments.length} 个附件</Tag>
                                    )}
                                </Space>
                            }
                            description={
                                <div>
                                    <div style={{ marginBottom: 8 }}>
                                        {item.content.substring(0, 100)}
                                        {item.content.length > 100 && '...'}
                                    </div>
                                    {item.notes && (
                                        <div style={{ fontSize: 12, color: '#888' }}>备注: {item.notes}</div>
                                    )}
                                    <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>
                                        创建时间: {new Date(item.created_at).toLocaleString('zh-CN')}
                                    </div>
                                </div>
                            }
                        />
                    </List.Item>
                )}
            />
        </Card>
    );
};
